import { Box, Chip } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

//Opciones gráfica
export const options = {
    maintainAspectRatio: true,
    aspectRatio: 2.5,
    plugins: {
        legend: {
            position: 'right'
        },
        datasetRadiusBuffer: 25,
        cutoutPercentage: 75
    }
};

const TopProductsDoughnut = ({ label, data }) => {
    return (
        <>
            <Box sx={{ mb: 2 }}>
                <Chip
                    label={label}
                    size="small"
                    color='primary'
                    sx={{ borderRadius: '6px', p: 1, fontWeight: 'bold' }}
                />
            </Box>
            <Doughnut data={data} options={options} />
        </>
    );
};

export default TopProductsDoughnut;